<template>
  <b-modal
    title="حذف زمان VIP برای زبان آموز"
    id="modal-vip-reserve-delete"
    centered
    ok-title="حذف"
    cancel-title="بستن"
    ok-variant="danger"
    @ok="deleteASingleVipReserve"
  >
    <b-container fluid v-if="vipReserveForDelete">
      <p>
        آیا از حذف زمان رزرو شده‌ از
        <span style="font-weight: bold">
          {{
            new Date(vipReserveForDelete.startDate).toLocaleTimeString(
              "fa-IR",
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
          }}
        </span>
        تا
        <span style="font-weight: bold">
          {{
            new Date(vipReserveForDelete.endDate).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
        </span>
        در تاریخ
        <span style="font-weight: bold">
          {{
            new Date(vipReserveForDelete.startDate).toLocaleDateString("fa-IR")
          }}
        </span>
        اطمینان دارید؟
      </p>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  emits: ["updateMasterPeriods"],
  props: {
    vipReserveForDelete: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async deleteASingleVipReserve() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteVipUserReserve = new DeleteVipUserReserve(_this);
        deleteVipUserReserve.setRequestParam({
          id: _this.vipReserveForDelete.vipUserReserveId,
        });
        await deleteVipUserReserve.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد",
                icon: "Trash2Icon",
                variant: "success",
                text: "رزرو با موفقیت حذف شد",
              },
            });
            _this.$emit("updateMasterPeriods");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "لطفا دوباره امتحان کنید!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BModal,
    BContainer,
  },
};
import { BModal, BContainer } from "bootstrap-vue";
import { DeleteVipUserReserve } from "@/libs/Api/VipUserReserve";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
